module.exports = __webpack_public_path__ + "static/media/E1.c9e8b28a.jpg";